var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
export var ICON_SIZES = {
    small: 1.6,
    normal: 2.0,
    inherit: "inherit",
};
var getSizeValue = function (size) {
    return "".concat(ICON_SIZES[size], "rem");
};
var StyledIcon = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  text-decoration: none;\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? "normal" : _b, _c = _a.color, color = _c === void 0 ? "inherit" : _c, theme = _a.theme;
    return ({
        color: color in theme.color ? theme.color[color] : color,
        fontSize: getSizeValue(size),
        minWidth: getSizeValue(size),
    });
});
export var Icon = function (props) {
    var name = props.name;
    return _jsx(StyledIcon, __assign({}, props, { className: "theme-icon--".concat(name) }));
};
export default Icon;
var templateObject_1;
